<template>
  <div style="display: flex; float: right; margin-left: 10px">
    <el-select
      v-model="currentTag"
      filterable
      multiple
      remote
      :remote-method="querySearchAsync"
      placeholder="筛选标签"
      @change="change"
      v-el-select-loadmore="loadMore"
      style="min-width: 100px"
    >
      <!-- <template>
        <el-input
          v-model="searchTagName"
          placeholder="输入标签名字搜索"
          style="width: 90%; margin-left: 5%"
          @keyup.enter.native="searchTag"
          size="small"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchTag"
          ></el-button>
        </el-input>
      </template> -->
      <!-- <el-option-group label="最近使用标签：">
        <el-option
          v-for="tagName in hotSearchTagName"
          :key="`history${tagName.id}`"
          :label="tagName.name"
          :value="tagName.id"
          @click.native="clickTagOption(tagName)"
        >
        </el-option>
      </el-option-group> -->
      <!-- <template #empty>
        <div style="margin-top: 6px">
          <el-input
            v-model="searchTagName"
            placeholder="输入标签名字搜索"
            style="width: 90%; margin-left: 5%"
            @keyup.enter.native="searchTag"
            size="small"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchTag"
            ></el-button>
          </el-input>
        </div>
        <div style="text-align: center; margin: 6px 0">
          <span style="color: #999999">内容为空</span>
        </div>
      </template> -->
      <el-option-group>
        <el-option
          v-for="item in searchTagList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          @click.native="clickTagOption(item)"
        >
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import tagsAPI from "@/server/api/tags";
import util from "@/util/util";

export default {
  components: {},

  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      noMore: false,
      searchTagName: "",
      searchTagList: [],
      currentTag: [],
      currentTagFull: [],
      hotSearchTagName: [],
      initTagIds: []
    };
  },

  props: {
    type: {
      type: Number,
      default: 0,
    },
    initList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  mounted() {
    this.getTagList();
    this.hotSearchTagName = util.getSearchTagNameCache();
    // if (this.hotSearchTagName.length > 0) {
    //   let usTga = this.hotSearchTagName.map((v) => {
    //     return v.id;
    //   });
    //   console.log(usTga);
    //   this.currentTag=usTga
    //   this.$emit("change", usTga);
    // }
  },
  watch: {
    initList: {
      immediate: true,
      handler: function(val) {
        if (val.length) {
          val.forEach((tag) => {
            this.searchTagList.push(tag);
            this.initTagIds.push(tag.id);
            this.currentTag.push(tag.id);
          });
          // this.change();
        }
      },
      deep: true
    }
  },
  methods: {
    reset() {
      // this.page = 1;
      // this.noMore = false;
      this.searchTagName = "";
      this.currentTag = [];
      this.currentTagFull = [];
      // this.getTagList();
    },
    getTagList() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        type: this.type, // 0内容标签  1用户标签
        name: this.searchTagName, // 非必需，搜索的时候用
      };
      tagsAPI.list(params).then((resp) => {
        if (resp.data) {
          // if (this.searchTagList[0] && params.page == 1) {
          //   return;
          // }
          if (resp.data.items.length > 0) {
            this.searchTagList = this.searchTagList.concat(resp.data.items.filter((val) => {
              return this.initTagIds.indexOf(val.id) === -1;
            }));
            if (resp.data.totalPages === this.page) {
              this.noMore = true;
            }
          } else {
            if (this.page === 1) {
              this.noMore = true;
              this.searchTagList = [];
            }
          }
        }
      });
    },
    loadMore() {
      if (!this.noMore) {
        this.page++;
        this.getTagList();
      }
    },
    searchTag() {
      this.page = 1;
      this.noMore = false;

      this.searchTagList = [];
      this.getTagList();
    },
    change() {
      this.$emit("change", this.currentTag);
    },
    getTagNamesByIdString(idString) {
      if (!idString) {
        return [];
      }
      let idList = idString.split(',').map((val) => parseInt(val));
      let returnList = [];
      this.searchTagList.forEach((tag) => {
        if (idList.indexOf(tag.id) > -1) {
          returnList.push({
            id: tag.id,
            name: tag.name
          })
        }
      });
      return returnList;
    },
    clickTagOption(item) {
      if (this.currentTag.indexOf(item.id) > -1) {
        this.currentTagFull.push({ id: item.id, name: item.name });
      } else {
        let pos = -1;
        this.currentTagFull.forEach((tag, idx) => {
          if (tag.id === item.id) {
            pos = idx;
          }
        });
        if (pos !== -1) {
          this.currentTagFull.splice(pos, 1);
        }
      }
    },
    setCache() {
      if (this.currentTag.length > 0) {
        console.log("tagFull", this.currentTagFull);
        this.searchTagList.forEach((searchTag) => {
          if (this.currentTag.indexOf(searchTag.id) > -1) {
            util.cacheSearchTagName({ id: searchTag.id, name: searchTag.name });
            this.hotSearchTagName = util.getSearchTagNameCache();
          }
        });
      }
    },
    querySearchAsync(query) {
      this.searchTagName = query;
      this.searchTag();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
